(() => {
  const initialized = new WeakSet();
  function setup(scope = document) {
    scope.querySelectorAll('.aw-pdp').forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      let variants = [];
      try { variants = JSON.parse(root.querySelector('[data-variant-json]')?.value || '[]'); } catch {}
      const money = cents => new Intl.NumberFormat('pl-PL', {style:'currency',currency:'PLN'}).format(cents / 100);
      function selectedVariant() {
        const id = root.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
        return variants.find(v => String(v.id) === String(id));
      }
      function sync() {
        const variant = selectedVariant();
        if (!variant) return;
        root.querySelectorAll('[data-aw-location-status]').forEach(el => {
          el.textContent = variant.available ? el.dataset.available : el.dataset.unavailable;
        });
        root.querySelectorAll('[data-aw-price]').forEach(el => el.textContent = money(variant.price));
        root.querySelectorAll('[data-aw-compare]').forEach(el => {
          el.hidden = !(variant.compare_at_price > variant.price);
          el.textContent = el.hidden ? '' : money(variant.compare_at_price);
        });
      }
      root.addEventListener('change', () => requestAnimationFrame(() => requestAnimationFrame(sync)));
      root.addEventListener('variant:change', sync);
      const price = root.querySelector('[data-product-price]');
      if (price) new MutationObserver(sync).observe(price, {subtree:true,childList:true,characterData:true});
      root.querySelectorAll('[data-aw-dispatch]').forEach(el => {
        const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Warsaw',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
        const value = type => Number(parts.find(p => p.type === type).value);
        const date = new Date(Date.UTC(value('year'),value('month')-1,value('day') + Number(el.dataset.days || 1),12));
        el.textContent = new Intl.DateTimeFormat('pl-PL', {timeZone:'Europe/Warsaw',weekday:'short',day:'numeric',month:'long'}).format(date);
      });
      root.querySelectorAll('[data-aw-area]').forEach(select => {
        select.addEventListener('change', () => {
          const location = select.closest('.aw-location');
          const message = location.querySelector('[data-aw-local-message]');
          message.textContent = message.dataset.template.replace('__CITY__', ({Warszawa:'Warszawie','Kraków':'Krakowie','Poznań':'Poznaniu','Łódź':'Łodzi','Wrocław':'Wrocławiu'})[select.value] || select.value);
          if (select.value === 'Wrocław') message.textContent = message.textContent.replace('w Wrocławiu', 'we Wrocławiu');
          location.querySelector('.aw-location__city').textContent = select.value;
        });
      });
      root.querySelectorAll('[data-aw-open]').forEach(button => {
        const dialog = document.getElementById(button.dataset.awOpen);
        if (!dialog) return;
        let previousOverflow;
        button.addEventListener('click', () => {
          sync();
          previousOverflow = document.documentElement.style.overflow;
          dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
        });
        dialog.querySelector('[data-aw-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = previousOverflow || '';
          button.focus({preventScroll:true});
        });
      });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
